import { render, staticRenderFns } from "./HeaderBaseLink.vue?vue&type=template&id=42483f8e&"
import script from "./HeaderBaseLink.vue?vue&type=script&lang=ts&"
export * from "./HeaderBaseLink.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderBaseLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports